import { Component, OnInit } from '@angular/core';
import {Chart} from "chart.js";
import {HcpService} from "./hcp.service";

@Component({
  selector: 'app-hcp',
  templateUrl: './hcp.component.html',
  styleUrls: ['./hcp.component.scss']
})
export class HcpComponent implements OnInit {

  public isLoading = false;
  public data = [];
  public labels = [];
  public raw = [];
  public render = {'filters': {'region': [
        "Béni Mellal - Khénifra",
        "Casablanca - Settat",
        "Dakhla - Oued Ed-Dahab",
        "Darâa - Tafilalet",
        "Fès - Meknès",
        "Guelmim - Oued Noun",
        "L’oriental",
        "Laâyoune - Sakia El Hamra",
        "Marrakech - Safi",
        "Rabat - Salé - Kénitra",
        "Souss - Massa",
        "Tanger - Tétouan - Al Hoceima"
      ]},
  'cols': {
    'region':[
      "Béni Mellal - Khénifra",
      "Casablanca - Settat",
      "Dakhla - Oued Ed-Dahab",
      "Darâa - Tafilalet",
      "Fès - Meknès",
      "Guelmim - Oued Noun",
      "L’oriental",
      "Laâyoune - Sakia El Hamra",
      "Marrakech - Safi",
      "Rabat - Salé - Kénitra",
      "Souss - Massa",
      "Tanger - Tétouan - Al Hoceima"
    ]
  }};
  public four = false;

  public doctors_cities = false;
  public population_cities = false;
  public menage_cities = false;





  constructor(private hcpService: HcpService) { }

  ngOnInit(): void {
    Chart.defaults.global.plugins.colorschemes.scheme = 'brewer.SetOne9';
    console.log('init');

    this.isLoading = true;
    this.hcpService.readAll().subscribe( res => {

      this.raw = res['data'];

      this.render['doctors'] = this.hcpService.getDoctors(this.raw, false);
      this.render['doctors_cities'] = this.hcpService.getDoctors(this.raw, true);

      this.render['population'] = this.hcpService.getPopulation(this.raw, false);
      this.render['population_cities'] = this.hcpService.getPopulation(this.raw, true);

      this.render['menage'] = this.hcpService.getMenages(this.raw, false);
      this.render['menage_cities'] = this.hcpService.getMenages(this.raw, true);

      console.log(this.render['doctors']);

      this.isLoading = false;
    })
  }

  public refAll(){
      let filted = this.raw.filter( d => this.render['filters']['region'].includes(d['region/city']) || this.render['filters']['region'].includes(d['region']) );

      this.render['doctors'] = this.hcpService.getDoctors(filted, false);
      this.render['doctors_cities'] = this.hcpService.getDoctors(filted, true);

      this.render['population'] = this.hcpService.getPopulation(filted, false);
      this.render['population_cities'] = this.hcpService.getPopulation(filted, true);

      this.render['menage'] = this.hcpService.getMenages(filted, false);
      this.render['menage_cities'] = this.hcpService.getMenages(filted, true);

      console.log(this.render['menage_cities']);
  }




  checked(ev, val, col) {
    if ( ev ) {
      if ( ! this.render['filters'][col].includes(val) ) {
        this.render['filters'][col].push(val);
        this.refAll();
      }

    } else {
      this.rmFilter(col, val);
      this.refAll();
    }
  }

  rmFilter(col, val){
    this.render['filters'][col] = this.render['filters'][col].filter(d => d !== val);
  }

}
